import * as React from "react";
import { App } from "./app"
import { ArticleGW } from "./ArticleGW"
import { BDKalkCore } from "./BDKalkCore"
import { Assert } from "./PADebug"
import { Debug } from "./PADebug"
import { DebugOnce } from "./PADebug"
import { Log } from "./PADebug"
import { PADebug } from "./PADebug"
import { ExtInfoViewGW } from "./ExtInfoViewGW"

interface CreationViewVm {
    core: BDKalkCore,
    app: App
}

interface CreationViewStates {
    displayMode: string
}

/*  CreationView is used to try new components out before introducing them. The page can only be 
    accessed while Prisassistenten is in debug mode, so it's for development only. The page is
    opened by clicking a toolbar button which also is only visible while in debug mode. */
export class CreationView extends React.Component<CreationViewVm, CreationViewStates> {
    constructor(props: CreationViewVm) {
        super(props)
        this.m_begunTyping = false
        this.m_deflectTries = 0
        this.m_statusData = "status: \"\" + \"\""
        this.m_lastValue = ""
        this.m_keptValue = ""
        this.m_shownString = "default"
    }
    
    // Sets the reference to this control within the article item on initiation
    componentWillMount() {
    }
    
    state = {
        displayMode: "initial"
    }

    handleBadInput() {
    }
    
    // Checks if the input is a valid number and enters it if so, or calls handleBadInput()
    processInput() {

        if (this.m_textInput == null) {
            return
        }

        var tested = this.props.core.GetApp().ParseToPositiveNumber(this.m_textInput.value)

        if (tested == null) {
            this.handleBadInput()
            return
        }
        
        /* The number has been concidered valid and will be entered as 
           a new amount for the article. This also means that the total sum
           display has to be up to date afterwards. The following actions
           however may cause the thread to be killed due to some update which
           replaces the owner of an ongoing process, so instead of updating
           the total sum display directly at the end here, this action is
           delayed to ensure it an active thread when the delay has passed. */
        setTimeout(this.props.core.RedrawTotalSum.bind(this.props.core), 40)

          // ...the same works for the update of ext info view, which might need a refresh due to 
          // how the total weight displayed there get affected by an amount change.
        setTimeout(this.props.core.UpdateExtInfoView.bind(this.props.core), 50)
        
          // var article = this.props.extInfoView.props.app.GetSelectedArticle()
          // this.props.extInfoView.InsertControlValue(tested, this)
    }

    // Handler for keydown events
    onKeyDown(key: string) {
        const previousValue = this.m_textInput.value
        this.m_statusData = "status: \"" + previousValue + "\" + \"" + key + "\""

        if ((key == "0") || (key == "1") || (key == "2") || (key == "3") || (key == "4") || (key == "5") || (key == "6") || (key == "7") || (key == "8") || (key == "9")) {
            if (this.m_begunTyping == false) {
                this.m_begunTyping = true
                this.CheckPulse()
                this.forceUpdate()
            }
            else {
                this.CheckPulse()
            }

            return
        }

        if ((key == ".") || (key == ",")) {
            if (this.m_begunTyping == false) {
                this.m_begunTyping = true
                this.CheckPulse()
                this.forceUpdate()
            }
            else {
                this.CheckPulse()
            }

            return
        }

        if ((key == "Backspace") || (key == "Delete")) {
            if (this.m_begunTyping == false) {
                this.m_begunTyping = true
                this.CheckPulse()
                this.forceUpdate()
            }
            else {
                this.CheckPulse()
            }

            return
        }
        
        if ((key == "ArrowLeft") || (key == "ArrowRight")) {
            return
        }
        
        if ((key == "ArrowUp") || (key == "ArrowDown")) {
            return
        }

        if ((key == "Enter") || (key == "Tab")) {
            this.processInput()
            return
        }

        if (key == "Control") {
            return
        }
        
        alert("Venligst benytt kun numeriske tegn! (Du tastet: \"" + key + "\")")
        this.DeflectChange(previousValue)

        return
    }

    // 
    TestMethod() {
        this.m_shownString = this.m_textInput.value
        this.m_textInput.value = "test:"
        this.m_textInput.autofocus = true
        this.forceUpdate()
    }

    // 
    DeflectChange(prev:string) {
        this.m_keptValue = prev
        this.m_deflectTries = 0
        setTimeout(this.OnDeflectChange.bind(this), 40)
        this.forceUpdate()
    }
    
    // 
    OnDeflectChange() {
        this.m_deflectTries++

        if (this.m_textInput) {
            if (this.m_textInput.value != this.m_keptValue) {
                this.m_textInput.value = this.m_keptValue 
                this.m_shownString = this.m_textInput.value
                this.m_textInput.autofocus = true
                this.forceUpdate()
            }
            else {
                if (this.m_deflectTries < 15) {
                    setTimeout(this.OnDeflectChange.bind(this), 100)
                }
            }
        }
    }
    
    // 
    CheckPulse() {
        this.m_lastValue = this.m_textInput.value
        setTimeout(this.OnCheckPulse.bind(this), 40)
    }

    // First reaction check 
    OnCheckPulse() {
        this.m_deflectTries++

        if (this.m_textInput) {
            if (this.m_textInput.value != this.m_lastValue) {
                this.m_shownString = this.m_textInput.value
                this.m_textInput.autofocus = true
                this.forceUpdate()
            }
            else {
                if (this.m_deflectTries < 15) {
                    setTimeout(this.OnCheckPulse.bind(this), 150)
                }
            }
        }
    }
    
    // Rendering the creative view
    render() {
        this.props.core.GetApp().ReFocus(300) // Calls a delayed focus to the input area
        
        // Grey amount is the value shown in ligth gray when input is active but nothing has been entered yet
        var greyAmount = "grey"

        if (this.m_begunTyping == true) {
            greyAmount = ""
        }

        return <div style={{ position: "relative", top:"30px", left:"30px" }}>
        
            {/* Numeric input */}
            <div style={{
                position: 'relative',
                width: '47px',
                height: '26px',
                backgroundImage: "url(images/ChoisePanelCollection.png)"
            }}>
                <input
                    type="text"
                    ref={(input) => { if (input != null) this.m_textInput = input }}
                    id="inputToBeFocusedOn"
                    onKeyDown={(par) => {this.onKeyDown(par.key) }}
                    style={{
                        position: 'relative',
                        width: '45px',
                        height: '26px',
                        top: '0px',
                        left: '0px',
                        border: '0px',
                        backgroundImage: "url(images/ChoisePanelCollection.png)"
                    }}>
                </input>
                <div style={{
                    color:"#BBBBBB",
                    position: 'relative',
                    width: '45px',
                    height: '26px',
                    top: '-24px',
                    left: '4px',
                    border: '0px'
                }}>{greyAmount}
                </div>
            </div>
            <div style={{height:"20px"}}></div>
            <div>{this.m_shownString}</div>
            <div>{this.m_statusData}</div>
        </div>;
    }

    m_begunTyping: boolean
    m_lastValue: string
    m_keptValue: string
    m_textInput: HTMLInputElement  // A handle to the input object
    m_statusData: string
    m_shownString: string
    m_deflectTries: number
}


// WEBPACK FOOTER //
// ./client/view/CreationView.tsx